import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6fbb7106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portList" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  role: "img",
  "aria-hidden": "true",
  width: "20",
  height: "8",
  viewBox: "0 0 20 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.25 7.79423L20 3.89711L13.25 0V3.39711H0V4.39711H13.25V7.79423Z",
  fill: "black"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "portInfo code"
}
const _hoisted_7 = {
  key: 1,
  class: "portInfo location"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "portInfo routeCode" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  role: "img",
  "aria-hidden": "true",
  width: "20",
  height: "8",
  viewBox: "0 0 20 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.25 7.79423L20 3.89711L13.25 0V3.39711H0V4.39711H13.25V7.79423Z",
  fill: "black"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

import { computed } from 'vue';
import { Skeletor } from 'vue-skeletor';
import { Icon } from '../../Atoms/index';
import { Port } from '../../types';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortList',
  props: {
    ports: {},
    iconName: {},
    showPortCode: { type: Boolean, default: false },
    showPortLocation: { type: Boolean },
    isLoading: { type: Boolean, default: false },
    textCode: { default: '' },
    showTextCode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const displayTextCode = computed(() => props.showTextCode && props.textCode && !props.isLoading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.iconName)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          "icon-name": _ctx.iconName,
          md: true
        }, null, 8, ["icon-name"]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ports, (port, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: _normalizeClass({ hasCode: port.portCode || port.location })
            }, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(port.name) + " ", 1),
                (_ctx.showPortCode && port.portCode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(port.portCode), 1))
                  : _createCommentVNode("", true),
                (_ctx.showPortLocation && port.location)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(port.location), 1))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128)),
          (displayTextCode.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, " : " + _toDisplayString(_ctx.$t('Text code')) + " " + _toDisplayString(_ctx.textCode), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (x, index) => {
            return _createElementVNode("li", { key: index }, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true),
              _createVNode(_unref(Skeletor), {
                class: "portSkeleton",
                height: "30"
              })
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})